import type { BootstrapData } from "@czasomat/contracts";

export const READER_CONFIG_KEY = "czasomat.reader.config.v1";
export type ReaderConfig = { version: 1; deviceId: string; locationId?: string; requirePhoto: boolean; savedAt: string };
type Storage = Pick<globalThis.Storage, "getItem" | "setItem">;

export function readReaderConfig(storage: Storage): ReaderConfig | null {
  try {
    const config = JSON.parse(storage.getItem(READER_CONFIG_KEY) ?? "null");
    if (config?.version !== 1 || typeof config.deviceId !== "string" || !config.deviceId ||
        (config.locationId !== undefined && (typeof config.locationId !== "string" || !config.locationId)) ||
        typeof config.requirePhoto !== "boolean" || typeof config.savedAt !== "string" || !Number.isFinite(Date.parse(config.savedAt))) return null;
    return config;
  } catch { return null; }
}

export function cacheReaderConfig(storage: Storage, data: Partial<BootstrapData>): ReaderConfig {
  const device = data.devices?.[0];
  if (!device?.id || typeof data.settings?.requirePhotoOnKiosk !== "boolean") {
    throw new Error("Serwer nie podał kompletnej konfiguracji czytnika. Nie zgadujemy urządzenia ani wymogu zdjęcia.");
  }
  const locationId = device.locationId || data.locations?.[0]?.id || undefined;
  const config: ReaderConfig = { version: 1, deviceId: device.id, locationId, requirePhoto: data.settings.requirePhotoOnKiosk, savedAt: new Date().toISOString() };
  try { storage.setItem(READER_CONFIG_KEY, JSON.stringify(config)); }
  catch { throw new Error("Nie można zapisać konfiguracji czytnika do pracy offline. Sprawdź dostępne miejsce i uprawnienia pamięci."); }
  return config;
}
